import React from 'react'
import {ProductsTable, UnverifiedProductsTable} from "../components";

export const ProductsPage: React.FC = () => <ProductsTable/>;

export const UnverifiedProductsPage: React.FC = () => <UnverifiedProductsTable/>;